import {
    getModuleRowsFromCompositionPayload,
    parseCatalogItemGetResponse,
} from "./compositionMediaUtils";

const TEXTURE_LIST_KEYS = ["texturedPictures", "texturePictures", "textures"];

const asArray = (value) => (Array.isArray(value) ? value : []);

const flattenModuleDetails = (row) => {
    if (row == null || typeof row !== "object") {
        return [];
    }
    const patterns = asArray(row.module?.detailPatterns ?? row.detailPatterns);
    const details = [];
    for (const pattern of patterns) {
        for (const detail of asArray(pattern?.details)) {
            if (detail != null && typeof detail === "object") {
                details.push(detail);
            }
        }
    }
    return details;
};

const pushPictureDto = (acc, dto) => {
    if (dto?.id == null) {
        return;
    }
    if (acc.some((row) => row.id === dto.id)) {
        return;
    }
    acc.push(dto);
};

const collectFromCompositionPayload = (composition) => {
    const acc = [];
    if (composition == null || typeof composition !== "object") {
        return acc;
    }

    for (const key of TEXTURE_LIST_KEYS) {
        asArray(composition[key]).forEach((row) => pushPictureDto(acc, row));
    }

    /**
     * GET /3d: иногда textures лежат в pictures.
     * Пропускаем gallery organization_composition_media — это фото карточки, не panel-текстуры.
     */
    asArray(composition.pictures).forEach((row) => {
        const url = row?.relativeUrl || row?.relativeUrlSmall;
        if (typeof url === "string" && url.includes("/organization_composition_media/")) {
            return;
        }
        pushPictureDto(acc, row);
    });

    for (const moduleRow of getModuleRowsFromCompositionPayload(composition)) {
        for (const detail of flattenModuleDetails(moduleRow)) {
            if (detail.picture?.id != null) {
                pushPictureDto(acc, detail.picture);
            }
            const textureId = detail.textureId;
            const textureUrl = detail.textureUrl
                || detail.picture?.relativeUrl
                || detail.picture?.relativeUrlSmall;
            if (textureId != null && textureUrl) {
                pushPictureDto(acc, {
                    id: textureId,
                    relativeUrl: textureUrl,
                    relativeUrlSmall: detail.picture?.relativeUrlSmall ?? textureUrl,
                });
            }
        }
    }

    return acc;
};

/** PictureDto[] из тела GET /customers/compositions/{id}/3d (first/second и вложенные поля). */
export const collectTexturedPicturesFromCustomer3dGet = (responseData) => {
    if (responseData == null) {
        return [];
    }

    const acc = [];
    if (typeof responseData === "object" && !Array.isArray(responseData)) {
        for (const key of TEXTURE_LIST_KEYS) {
            asArray(responseData[key]).forEach((row) => pushPictureDto(acc, row));
        }
    }

    const {template, draft} = parseCatalogItemGetResponse(responseData);
    collectFromCompositionPayload(template).forEach((row) => pushPictureDto(acc, row));
    collectFromCompositionPayload(draft).forEach((row) => pushPictureDto(acc, row));

    return acc;
};
